/**
 * ProtectedRoute component
 *
 * Wraps a route that requires authentication.
 * Redirects to login if user is not authenticated.
 * Shows loading state while auth state is being initialized.
 *
 * Extracted from the legacy `App.tsx` route tree so it can be reused by
 * the `vite-react-ssg` route records in `src/app/router.tsx`. Protected
 * routes are never part of `MARKETING_ROUTES` (see
 * `src/app/marketingRoutes.ts`), so this component is only ever exercised
 * client-side — it is not statically rendered.
 */
import { Navigate } from 'react-router-dom';
import { useAuth } from './providers';

export function ProtectedRoute({
  element,
}: {
  element: React.ReactElement;
}): React.ReactElement {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return element;
}
